<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: "App",
		methods: {
			_isMobile() {
				let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
				return flag;
			}
		},
		mounted() {
			var random=Math.random();
			var path="ldt";
			var parm=window.location.href.split('?');
			if(parm.length>1){
				var cs = parm[1].split('&');
				if(cs.length>0){
					path=cs[0]
				}
			}
			if (!this._isMobile()) {
				this.$router.replace("/pcIndex?"+path+"&"+random);
			} else {
				this.$router.replace("/iphoneIndex?"+path+"&"+random);
			}
		}
	};
</script>

<style>
	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		width: 100vw;
		overflow-x: hidden;
	}
	body {
		overflow: -moz-scrollbars-none;
	}
	body {
		-ms-overflow-style: none;
	}
	body::-webkit-scrollbar {
		width: 0 !important;
	}
	* {
		margin: 0;
		padding: 0;
	}
  .ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue